import { getProjectScenes } from '../utils';

export default {
  state: {
    infographics: null,
    infographicsScenes: {},
  },
  getters: {
    getInfographics: (state) => state.infographics,
    getInfographicsScenes: (state) => state.infographicsScenes,
  },
  mutations: {
    setInfographics(state, payload) {
      state.infographics = payload;
      state.infographicsScenes = getProjectScenes(payload);
    },
  },
};
